<template>
  <div class="pricing-page">
    <Header />
    <div class="pricing-content">
      <el-card class="form-card">
        <header class="form-heading">
          <div class="brand">
            <img src="@/assets/DiCloudAccessLogo.svg" alt="DiCloudAccess" class="brand-logo">
            <div class="brand-text">
              <span class="brand-en">DiCloudAccess</span>
              <span class="brand-zh">点云通</span>
            </div>
          </div>
          <h1>价格咨询</h1>
        </header>
        <p class="description">请留下您的联系方式，我们的销售团队将尽快与您联系，为您提供最适合的价格方案。</p>
        <el-form :model="form" :rules="rules" ref="formRef" label-position="top" class="contact-form">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="公司" prop="company">
                <el-input v-model="form.company" placeholder="请输入您的公司名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12">
              <el-form-item label="电话" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入您的联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="form.email" placeholder="请输入您的邮箱地址"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="留言" prop="message">
            <el-input type="textarea" v-model="form.message" rows="4" placeholder="请输入您的留言或需求描述"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm" class="submit-btn">提交咨询</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { ElMessage } from 'element-plus';
import Header from './Header.vue';
import authApi from '../js/connect';

const formRef = ref(null);

const form = reactive({
  name: '',
  company: '',
  phone: '',
  email: '',
  message: ''
});

const rules = {
  name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
  company: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
  phone: [{ required: true, message: '请输入电话号码', trigger: 'blur' }],
  email: [
    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
  ]
};

const submitForm = () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      try {
        const response = await authApi.submitInterest(form);
        ElMessage.success(response.data.message);
        formRef.value.resetFields();
      } catch (error) {
        if (error.response && error.response.status === 429) {
          ElMessage.warning(error.response.data.error);
        } else {
          console.error('提交失败:', error);
          ElMessage.error('提交失败，请稍后重试');
        }
      }
    } else {
      return false;
    }
  });
};
</script>

<style scoped>
.pricing-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--dca-bg);
}

.pricing-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
}

.form-card {
  width: 100%;
  max-width: 800px;
  background-color: var(--dca-surface);
  border: 1px solid var(--dca-border);
  border-radius: var(--dca-radius-lg);
  box-shadow: none;
  --el-text-color-regular: var(--dca-text);
  --el-text-color-primary: var(--dca-text);
}

.form-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 8px;
}

.brand-logo {
  height: 24px;
}

.brand-text {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.brand-en {
  font-size: 0.9em;
  font-weight: var(--dca-fw-semibold);
  color: var(--dca-text-muted);
  letter-spacing: -0.01em;
}

.brand-zh {
  font-size: 0.82em;
  font-weight: var(--dca-fw-regular);
  color: var(--dca-text-faint);
}

h1 {
  text-align: center;
  color: var(--dca-text);
  margin: 0;
  font-size: 28px;
  font-weight: var(--dca-fw-semibold);
  letter-spacing: -0.02em;
}

.description {
  text-align: center;
  color: var(--dca-text-muted);
  margin-bottom: 28px;
  font-size: 15px;
  font-weight: var(--dca-fw-regular);
}

.contact-form :deep(.el-form-item__label) {
  color: var(--dca-text-muted);
  font-weight: 400;
}

.contact-form :deep(.el-form-item__error) {
  position: static;
  padding-top: 6px;
  line-height: 1.4;
}

.contact-form :deep(.el-input__wrapper),
.contact-form :deep(.el-textarea__inner) {
  background-color: var(--dca-surface-2);
  box-shadow: 0 0 0 1px var(--dca-border) inset;
}

.contact-form :deep(.el-input__inner),
.contact-form :deep(.el-textarea__inner) {
  color: var(--dca-text);
  font-weight: 400;
}

.contact-form {
  padding: 20px 20px 0;
}

.contact-form :deep(.el-form-item:last-child) {
  margin-bottom: 0;
}

.submit-btn {
  width: 100%;
  padding: 12px 20px;
  font-size: 16px;
}

.form-card :deep(.el-card__body) {
  padding-bottom: 28px;
}

@media (max-width: 768px) {
  .pricing-content {
    padding: 20px 10px;
  }

  .form-card {
    box-shadow: none;
  }

  .contact-form :deep(.el-form-item) {
    margin-bottom: 16px;
  }

  .contact-form :deep(.el-form-item:last-child) {
    margin-bottom: 0;
  }

  .form-card :deep(.el-card__body) {
    padding-bottom: 20px;
  }
}
</style>